/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Daily_PicksInputs */

const en_daily_picks = /** @type {(inputs: Daily_PicksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daily Picks`)
};

const ar_daily_picks = /** @type {(inputs: Daily_PicksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مختارات اليوم`)
};

const de_daily_picks = /** @type {(inputs: Daily_PicksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tägliche Auswahl`)
};

const es_daily_picks = /** @type {(inputs: Daily_PicksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selección diaria`)
};

const fr_daily_picks = /** @type {(inputs: Daily_PicksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélection du jour`)
};

const it_daily_picks = /** @type {(inputs: Daily_PicksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scelte del giorno`)
};

const ja_daily_picks = /** @type {(inputs: Daily_PicksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デイリーピック`)
};

const ko_daily_picks = /** @type {(inputs: Daily_PicksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오늘의 추천`)
};

const pt_br_daily_picks = /** @type {(inputs: Daily_PicksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolhas do dia`)
};

const ru_daily_picks = /** @type {(inputs: Daily_PicksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ежедневная подборка`)
};

const th_daily_picks = /** @type {(inputs: Daily_PicksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายการแนะนำประจำวัน`)
};

const tr_daily_picks = /** @type {(inputs: Daily_PicksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Günün Seçimleri`)
};

const zh_cn_daily_picks = /** @type {(inputs: Daily_PicksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每日精选`)
};

const zh_tw_daily_picks = /** @type {(inputs: Daily_PicksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每日精選`)
};

/**
* | output |
* | --- |
* | "Daily Picks" |
*
* @param {Daily_PicksInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_picks = /** @type {((inputs?: Daily_PicksInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_PicksInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_picks(inputs)
	if (locale === "ar") return ar_daily_picks(inputs)
	if (locale === "de") return de_daily_picks(inputs)
	if (locale === "es") return es_daily_picks(inputs)
	if (locale === "fr") return fr_daily_picks(inputs)
	if (locale === "it") return it_daily_picks(inputs)
	if (locale === "ja") return ja_daily_picks(inputs)
	if (locale === "ko") return ko_daily_picks(inputs)
	if (locale === "pt_br") return pt_br_daily_picks(inputs)
	if (locale === "ru") return ru_daily_picks(inputs)
	if (locale === "th") return th_daily_picks(inputs)
	if (locale === "tr") return tr_daily_picks(inputs)
	if (locale === "zh_cn") return zh_cn_daily_picks(inputs)
	return zh_tw_daily_picks(inputs)
});